export default __webpack_public_path__ + "static/media/pebble-red.206ce582.svg";